<template>
    <b-modal
        id="modalInfoSendToken"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        modal-class="modal-dark"
        centered
        title="Validação de segurança"
        hide-footer
        @hide="handleClose"
    >
        <b-card-text>
            <b-row>
                <b-col class="col-md-12">
                    <h6>Um email foi enviado para <b>{{criptMail}}</b> com um código de verificação.</h6>
                    <h6>Utilize este código para prosseguir com a atualização da senha.</h6>
                    <div class="mt-5">
                        <b-form-input v-model="token" placeholder="Código de verificação"></b-form-input>
                    </div>
                </b-col>
                <b-col class="col-md-12 mt-5">
                    <b-button
                        variant="dark"
                        type="button"
                        @click="validateToken"
                        block
                        :disabled="loading"
                    >
                        <b-spinner small type="grow" label="Loading..." v-if="loading"></b-spinner>
                        <span v-else>Validar código</span>
                    </b-button>
                </b-col>
            </b-row>
        </b-card-text>
    </b-modal>
</template>

<script>

import TokenService from "@/services/TokenService";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
    name: "MailToken",
    props:{
        id:{
            type: Number,
            required: true,
        },
        mail:{
            type: String,
            required: true,
        }
    },
    mounted() {
        this.$bvModal.show('modalInfoSendToken');
    },
    data() {
        return {
            loading: false,
            token: null,
        }
    },
    computed:{
        criptMail() {
            let email = this.mail;
            email = email.split('@');
            let emailCorrect = email[0];

            const total = Math.round(emailCorrect.length / 2) - 1;

            const partEmail = emailCorrect.substr(0, total)

            let mask = null;

            for(let i=0; i < partEmail.length; i++) {
                if (i === 0) {
                    mask = '*';
                } else {
                    mask = mask + '*';
                }

            }

            emailCorrect = emailCorrect.replace(partEmail, mask)

            return emailCorrect+'@'+email[1];
        }
    },
    methods:{
        validateToken() {
            if (this.token === null) {
                this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Oops!',
                             icon: 'BellIcon',
                             text: 'Informe o token que foi enviado no email!',
                            variant: 'danger',
                        },
                    },
                    {
                        position: 'top-center'
                    })
            } else {
                this.loading = true;
                TokenService.validateToken(this.id, this.token).then(resp => {
                    this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: 'Sucesso!',
                                icon: 'BellIcon',
                                text: resp.data.message,
                                variant: 'info',
                            },
                        },
                        {
                            position: 'top-center'
                        })

                    this.handleClose(true)

                    this.loading = false;
                }).catch(err => {
                    this.loading = false;

                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Oops!',
                            icon: 'BellIcon',
                            text: err.response.data.message,
                            variant: 'danger',
                        },
                    },
                    {
                        position: 'top-center'
                    })
                })
            }
        },
        handleClose(tokenValidated = false) {
            this.$emit('closedModal', {tokenValidated: typeof tokenValidated !== "boolean" ? false : tokenValidated})
        }
    }
}
</script>

<style scoped>

</style>